// import api from "@/api";



// export async function pregledBaranja(payload) {
//   const res = await api.post("/baranja/pregled", payload, {
//     headers: { "Content-Type": "application/json" },
//   });
//   return res.data;
// }





import api from "@/api";


export async function dodadiBaranja(payload) {
  const res = await api.post("/baranja/add", payload, {
    headers: { "Content-Type": "application/json" },
  });
  return res.data;
}
/*
  Овој сервис НЕ смее да праќа на /baranja/add.
  Ново барање се праќа само од baranjaService.js.

  Оваа функција ја оставаме само за да не паѓаат старите компоненти
  кои сè уште ја повикуваат dodadiBaranja().
*/
// export async function dodadiBaranja(payload) {
//   // console.warn(
//   //   "dodadiBaranja() од baranjaApiService.js е исклучена. Барањето веќе се испраќа преку baranjaService.js.",
//   //   payload
//   // );

//   return {
//     ok: true,
//     skipped: true,
//     message: "Испраќањето е прескокнато за да не се прати втор mail.",
//   };
// }

/* Преглед на барања */
export async function pregledBaranja(payload) {
  const res = await api.post("/baranja/pregled", payload, {
    headers: {
      "Content-Type": "application/json",
    },
  });

  return res.data;
}